<template>
  <div class="bill-exchange-checkout">
    <div class="row-center-vertical mb-2">
      <b-col md="6" class="no-side">
        <p class="textPayment mb-0">Thanh toán xuất đổi</p>
      </b-col>
    </div>

    <b-row class="mb-1">
      <b-col md="7">
        <span class="textTitlePayment">Tổng HĐ xuất đổi</span>
      </b-col>
      <b-col md="5" class="text-right">
        <span class="textPayment">{{ convertPrice(giveValue) }}</span>
      </b-col>
    </b-row>
    <b-row class="mb-1">
      <b-col md="7">
        <span class="textTitlePayment">Credit HĐ gốc</span>
      </b-col>
      <b-col md="5" class="text-right">
        <span class="textPayment text-success">- {{ convertPrice(exchangeCredit) }}</span>
      </b-col>
    </b-row>
    <b-row class="mb-1">
      <b-col md="7">
        <span class="textTitlePayment font-weight-bold">Khách cần trả</span>
      </b-col>
      <b-col md="5" class="text-right">
        <span class="textPayment font-weight-bold text-primary">{{
          convertPrice(amountDue)
        }}</span>
      </b-col>
    </b-row>
    <b-row class="mb-1" v-if="refundPendingAmount > 0">
      <b-col md="7">
        <span class="textTitlePayment text-muted">Chênh cần hoàn (phase sau)</span>
      </b-col>
      <b-col md="5" class="text-right">
        <span class="textPayment text-warning">{{
          convertPrice(refundPendingAmount)
        }}</span>
      </b-col>
    </b-row>
    <b-row class="mb-1" v-if="requiresPayment">
      <b-col md="7">
        <span class="textTitlePayment">Đã thu</span>
      </b-col>
      <b-col md="5" class="text-right">
        <span class="textPayment">{{ convertPrice(totalPaid) }}</span>
      </b-col>
    </b-row>
    <b-row class="mb-2" v-if="requiresPayment && paymentRemain > 0">
      <b-col md="7">
        <span class="textTitlePayment text-danger">Còn thiếu</span>
      </b-col>
      <b-col md="5" class="text-right">
        <span class="textPayment text-danger">{{ convertPrice(paymentRemain) }}</span>
      </b-col>
    </b-row>

    <BillPayment
      v-if="requiresPayment && paymentModel.storeId"
      :key="'exchange-payment-' + paymentModel.storeId"
      ref="bill-payment"
      :finalAmount="amountDue"
      :billData="paymentModel"
      :onSubmiting="onSubmiting"
      :disabled="false"
      :isAllowQRCode="false"
      :excludes="paymentExcludes"
      v-on:onUpdate="onUpdatePayment"
      v-on:receive-payment="onUpdatePayment"
      v-on:receive-payment-mul="onUpdatePaymentV2"
    />
  </div>
</template>

<script>
import _sumBy from 'lodash/sumBy';
import { cloneDeep, convertPrice } from '@/utils/common';
import { PAYMENT_TYPE } from '@/utils/enum';
import BillPayment from './BillPayment.vue';

export default {
  components: { BillPayment },
  props: {
    giveValue: { type: Number, default: 0 },
    exchangeCredit: { type: Number, default: 0 },
    amountDue: { type: Number, default: 0 },
    refundPendingAmount: { type: Number, default: 0 },
    requiresPayment: { type: Boolean, default: false },
    paymentModel: { type: Object, required: true },
    onSubmiting: { type: Boolean, default: false },
  },
  data() {
    return {
      paymentExcludes: {
        fields: [],
        paymentMethods: [
          PAYMENT_TYPE.CREDIT,
          PAYMENT_TYPE.INSTALLMENT,
          PAYMENT_TYPE.REFUND,
          PAYMENT_TYPE.DEPOSIT,
          PAYMENT_TYPE.CREDIT_FEE,
        ],
      },
    };
  },
  computed: {
    totalPaid() {
      const payments = [
        ...(this.paymentModel.cash || []),
        ...(this.paymentModel.transfer || []),
      ];
      return _sumBy(payments, (item) => Number(item.paymentAmount) || 0);
    },
    paymentRemain() {
      return Math.max(0, (this.amountDue || 0) - this.totalPaid);
    },
  },
  methods: {
    convertPrice,
    onUpdatePayment(paymentInfo) {
      this.$emit('update-payment-info', cloneDeep(paymentInfo));
    },
    onUpdatePaymentV2(items = [], type) {
      this.$emit('update-payment-rows', { items, type });
    },
  },
};
</script>

<style lang="scss" scoped>
.bill-exchange-checkout {
  .textPayment {
    font-weight: 600;
  }
  .textTitlePayment {
    font-size: 0.85rem;
  }
  .no-side {
    padding-left: 0;
    padding-right: 0;
  }
}
</style>
